import lightbox from './glightbox';
import { Localize } from './utilities/localize';

export class ToSOverlay {
  constructor(node) {
    this.rootElement = node;
    this.downloadId = this.rootElement.hash;
    this.rootElement.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    if (this.rootElement.id) {
      // Keep this for backwards-compatibility reasons with content block 'Download' for now "as-is", maybe unify (or delete, if the other element is not needed anymore).
      const preExistingModal = document.querySelector(`${this.rootElement.id}`);
      if (preExistingModal) {
        this.lightbox = this.rootElement.closest('body').querySelector('.glightbox-container').querySelector(this.downloadId);

        this.formElement = this.lightbox.querySelector('form');
        this.labelElement = this.lightbox.querySelector('.c-form-element-checkbox__label');
        this.checkboxElement = this.lightbox.querySelector('.c-form-element-checkbox');
        this.buttonElement = this.lightbox.querySelector('.c-button');
        this.errorText = this.lightbox.querySelector('.c-form-input--error-icon');

        this.labelElement.addEventListener('click', () => {

          if (this.checkboxElement.hasAttribute('checked') !== null) {
            this.checkboxElement.setAttribute('checked', 'checked');
          }
        });

        this.buttonElement.addEventListener('click', () => {

          this.downloadLink = this.buttonElement.getAttribute('data-file');

          if (!this.checkboxElement.hasAttribute('checked')) {
            event.preventDefault();
            this.labelElement.classList.add('c-form-element-radiobutton--error');
            if (this.errorText.classList.contains('is-hidden')) {
              this.errorText.classList.remove('is-hidden');
            }
          }
        });
      } else {
        this.rootElement.addEventListener('click', this.initializeLightbox(this));

        this.lightbox = this.rootElement.closest('body').querySelector('.glightbox-container');

        this.formElement = this.lightbox.querySelector('form');
        this.labelElement = this.lightbox.querySelector('.c-form-element-checkbox__label');
        this.checkboxElement = this.lightbox.querySelector('.c-form-element-checkbox');
        this.buttonElement = this.lightbox.querySelector('.c-button');
        this.errorText = this.lightbox.querySelector('.c-form-input--error-icon');

        this.labelElement.addEventListener('click', () => {

          if (this.checkboxElement.hasAttribute('checked') !== null) {
            this.checkboxElement.setAttribute('checked', 'checked');
          }
        });

        this.buttonElement.addEventListener('click', (event) => {
          if (!this.checkboxElement.hasAttribute('checked')) {
            event.preventDefault();
            this.labelElement.classList.add('c-form-element-radiobutton--error');
            if (this.errorText.classList.contains('is-hidden')) {
              this.errorText.classList.remove('is-hidden');
            }
          }
        });
      }
    }
  }

  initializeLightbox() {
    const lightboxHtml = `<div class="c-modal">
                                    <div class="c-modal__inner">
                                        <div class="c-modal__content">
                                            <span class="u-headline u-h3">${Localize('js.download.accept_tos.headline', '')}</span>
                                            <p class="c-paragraph">${Localize('js.download.accept_tos.text', '')}</p>
                                            <p class="c-paragraph"><a href="${this.rootElement.getAttribute('data-download-with-tos')}" target="_blank" referrerpolicy="origin">${Localize('js.download.accept_tos.link', '')}</a></p>

                                            <form action="" method="get" class="c-special-tos__accept-form" data-special-tos-accept>
                                                <div class="c-form-group">
                                                    <input type="checkbox" id="accept_tos" class="c-form-element c-form-element-checkbox" tabindex="0" required />
                                                    <label for="accept_tos" class="c-form-element-checkbox__label">${Localize('js.download.accept_tos.accept_label', '')}</label>
                                                    <div class="c-form-input--error-icon is-hidden"><i class="bi bi-x"></i>${Localize('js.download.accept_tos.error', '')}</div>
                                                </div>
                                                <div class="c-form-group c-form-group--right">
                                                    <a href="${this.rootElement.getAttribute('data-image-public-url')}" target="_blank" class="c-button" referrerpolicy="origin">${Localize('js.download.accept_tos.button_label', '')}</a>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>`;

    lightbox.setElements([
      {
        'content': lightboxHtml
      }
    ]);

    lightbox.open();
  }
}

const toSForms = document.querySelectorAll('[data-download-with-tos]');
toSForms.forEach((toSForm) => {
  new ToSOverlay(toSForm);
});
